module.exports = "/fast-coin/img/coin_start_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin_start_2.png
// module id = 2383
// module chunks = 5